import { useEffect } from "react";
import { Link, createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RequireAuth } from "@/components/RequireAuth";
import { AppShell } from "@/components/layout/AppShell";
import { AdjustmentNoteForm } from "@/components/payroll/AdjustmentNoteForm";
import { DianReadinessBanner } from "@/components/companies/DianReadinessBanner";
import { useActiveCompany } from "@/lib/company-context";

export const Route = createFileRoute("/companies/$companyId/nomina/ajustes/new")({
  component: NewAdjustmentPage,
});

function NewAdjustmentPage() {
  return (
    <RequireAuth>
      <AppShell>
        <NewAdjustmentContent />
      </AppShell>
    </RequireAuth>
  );
}

function NewAdjustmentContent() {
  const { t } = useTranslation();
  const { companyId } = Route.useParams();
  const navigate = useNavigate();
  const { setActiveCompanyId } = useActiveCompany();

  useEffect(() => {
    if (companyId) setActiveCompanyId(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4">
      <DianReadinessBanner companyId={companyId} documentKind="nomina_ajuste" />
      <Link
        to="/companies/$companyId/nomina/ajustes"
        params={{ companyId }}
        className="inline-flex w-fit items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-3 w-3" />
        {t("payroll.adjustment.new.back")}
      </Link>
      <h1 className="text-2xl font-semibold tracking-tight">
        {t("payroll.adjustment.new.title")}
      </h1>
      <p className="text-sm text-muted-foreground">
        {t("payroll.adjustment.new.subtitle")}
      </p>

      <AdjustmentNoteForm
        companyId={companyId}
        onCreated={(result) => {
          void navigate({
            to: "/companies/$companyId/nomina/ajustes/$adjustmentId",
            params: { companyId, adjustmentId: result.id },
          });
        }}
      />
    </div>
  );
}
